// FF-DOCK-1 — React subscription for Firefly floating vs sidebar chrome.

import { useCallback, useEffect, useState } from "react";
import {
  getFireflyDisplayMode,
  setFireflyDisplayMode as persistFireflyDisplayMode,
  subscribeFireflyDisplayMode,
  type FireflyDisplayMode,
} from "@/lib/firefly/fireflyDisplayMode";

export type UseFireflyDisplayModeResult = {
  mode: FireflyDisplayMode;
  setMode: (next: FireflyDisplayMode) => void;
};

export function useFireflyDisplayMode(): UseFireflyDisplayModeResult {
  const [mode, setModeState] = useState<FireflyDisplayMode>(getFireflyDisplayMode);

  useEffect(() => {
    const unsubscribe = subscribeFireflyDisplayMode(setModeState);
    setModeState(getFireflyDisplayMode());
    return unsubscribe;
  }, []);

  const setMode = useCallback((next: FireflyDisplayMode) => {
    persistFireflyDisplayMode(next);
  }, []);

  return { mode, setMode };
}
